<template>
    <div class="searchView">
        <div class="search">
            <Button class="select" @click="showPicker = true">
                <div class="select">
                    <span>{{selectText}}</span>
                    <span style="margin: 1vw 0 0 0.5vw; color: #d2d2d2">
                        <Icon name="arrow-down"/>
                    </span>
                </div>
            </Button>
            <div class="inputView">
                    <span style="margin-top: 1vw">
                        <Icon name="search" size="5vw"/>
                    </span>
                <input class="input" v-model="searchFrom.value" type="text" :placeholder="placeholder">
            </div>
            <Button class="searchBtn" @click="onSearch">
                <span>搜索</span>
            </Button>
        </div>
        <Popup v-model="showPicker" position="bottom">
            <Picker
                show-toolbar
                :columns="list"
                @cancel="showPicker = false"
                @confirm="onConfirm"
            />
        </Popup>
    </div>
</template>

<script>
    /*
    * 搜索组件
    * */
    import {Icon, Button, Picker, Popup} from 'vant';
    export default {
        name: "Search",
        components: {
            Icon, Button, Picker, Popup
        },
        props: {
            list: {
                type: Array,
                default: []
            },
            placeholder: {
                type: String,
                default: ''
            },
            activeStatus: {
                type: Object,
                default: {}
            }
        },
        watch: {
            activeStatus: {
                handler(obj) {
                    if (obj.text) {
                        this.selectText = obj.text;
                        this.searchFrom.status = obj.value;
                    }
                },
                immediate: true,
            }
        },
        data() {
            return {
                showPicker: false,
                selectText: '',
                searchFrom: {
                    value: '',
                    status: ''
                }
            }
        },
        methods: {
            onSearch() {
                this.$emit('click', this.searchFrom);
            },
            onConfirm(obj) {
                this.searchFrom.status = obj.value;
                this.selectText = obj.text;
                this.showPicker = false;
            },
        }
    }
</script>

<style lang='less' scoped>
    .search {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 8.5vw;
        padding: 0 3vw;

        .select {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 19vw;
            height: 8.5vw;
            border: none;
            background-color: #ffffff;
            border-radius: 4.3vw;
            font-size: 4vw;
            color: #43a2fe;
        }

        .inputView {
            overflow: hidden;
            display: flex;
            align-items: center;
            width: 54.1vw;
            height: 8.5vw;
            padding-left: 7.7vw;
            background-color: #ffffff;
            border-radius: 4.3vw;
            color: #c3c3c3;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;

            .input {
                flex: 1;
                display: block;
                height: 100%;
                line-height: 8.5vw;
                margin-left: 2vw;
                border: none;
                font-size: 4vw;
                color: #555;

                &::placeholder {
                    color: #c3c3c3;
                }
            }
        }

        .searchBtn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 18.4vw;
            height: 8.5vw;
            border: none;
            line-height: 8.5vw;
            background-color: #ffffff;
            border-radius: 4.3vw;
            font-size: 4vw;
            color: #43a2fe;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Search.vue